import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, odsCallOutBoxs } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";

interface State {
    showConfirmationDialog: boolean;
    removeIndex: number;
}

interface Props {
    ele: any;
    dialogVisible: boolean;
    isEng: boolean;
    callback: any;
}

export class DialogforRadioOptions extends React.Component<Props, State> {
    dateTypeFieldList = [];

    constructor(props: Props) {
        super(props);
        this.state = {
            showConfirmationDialog: false,
            removeIndex: -1,
        };
    }


    render() {
        return (
            <>
                {/* @ts-ignore */}
                <Dialog
                    header={'Radio Button Options'}
                    visible={this.props.dialogVisible}
                    footer={this.renderFooter()}
                    style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.renderOptions()}
                </Dialog>
            </>
        )
    }

    renderOptions = () => {
        let html = [];

        html.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng? this.props.ele.hintExpansionTitle: this.props.ele.hintExpansionTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.hintExpansionTitle = e.target.value;
                            else {
                                this.props.ele.hintExpansionTitleFRA = e.target.value;
                            }
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            this.props.ele.callOutBoxType = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.isEng? this.props.ele.callOutBoxTitle:this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else 
                            this.props.ele.callOutBoxTitleFRA = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng? this.props.ele.callOutBoxBody: this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else 
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                        }}></Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                     value={this.props.ele.Script} onChange={(e) => {
                        this.props.ele.Script = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>
             </div>
        )

        return html;
    }


    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
            </div>
        );
    }
}
